import React, {Component} from 'react';
import './GerberReview.css';
import InitialQuotationState from "../QuotationForm/InitialQuotationState";
import {RESOURCE_BASE_URL} from "../../../configuration";
import axios from "axios";
import {FormattedMessage} from "react-intl";
import GerberReviewPage from "./GerberReviewPage/GerberReviewPage";

class GerberReview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.userId,
            minLineDist: '',
            minLineWidth: '',
            setLength: '',
            setWidth: '',
            smallestHole: '',
            stencilLayer: '',
            tdrRes: {}
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
        }
    }

    componentDidMount() {

        document.getElementsByClassName("w1280").innerHtml = "";

    }

    getReviewResult = () => {
        let resourceUrl = RESOURCE_BASE_URL + 'api/jlcpcb/gerber/review';

        let postData = {
            language: 0,
            key: "1475"
        };

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.post(resourceUrl, postData, axiosConfig)
            .then((res) => {

                this.setState(
                    {
                        minLineDist: res.data.result.minLineDist,
                        minLineWidth: res.data.result.minLineWidth,
                        setLength: res.data.result.setLength,
                        setWidth: res.data.result.setWidth,
                        smallestHole: res.data.result.smallestHole,
                        stencilLayer: res.data.result.stencilLayer,
                        tdrRes: res.data.result.technologyDiscernRecordResult
                    }
                );

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            })

    };


    render() {
        let {tdrRes} = this.state;
        // console.log("GERBER VIEWER URL ====================================> ", this.props.location.imageUrl);
        return (

            <div>
                <div className="gerber-review-content">
                    <div className="gerber-review-div">
                        <div className='row'>
                            <div className="review-title">
                                <div className="title-1"><FormattedMessage id="app.gerber.review.title"
                                                      defaultMessage="Analysis Results"
                                                      description=""/></div>
                            </div>
                            <hr/>

                            <GerberReviewPage/>


                            <hr/>
                        </div>

                    </div>
                </div>

            </div>
    );
    }

    }

    export default GerberReview;



// WEBPACK FOOTER //
// ./src/components/Site/GerberReview/GerberReview.js